module.exports = __webpack_public_path__ + "img/bd.32e1ddfa.svg";